/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import s from './index.less';

interface LoginCardItemProps {
  data: any;
  onClick: any;
}

const LoginCardItem: React.FC<LoginCardItemProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { data, onClick } = props;

    return (
      <div className={s.container} onClick={() => onClick(data.value)}>
        <img src={data.url} className={s.top} alt="" />
        <div className={s.bottom}>
          <span className={s.name}>{data.name}</span>
          <span className={s.content}>{data.content}</span>
        </div>
      </div>
    );
  })
);
export default LoginCardItem;
